import { Component, Input, ChangeDetectionStrategy, ContentChild, Optional, ElementRef, Renderer2 } from '@angular/core';
import { NglFormGroupAlternate } from './group-alt';
import { NglFormCheckbox } from '../elements/input';
import { NglFormLabelTemplate, getFormLabel } from '../form-label';
import { uniqueId } from '../../util/util';
var NglFormGroupElement = (function () {
    function NglFormGroupElement(groupAlt, element, renderer) {
        this.groupAlt = groupAlt;
        this.element = element;
        this.renderer = renderer;
        this.uid = uniqueId('form_element');
    }
    Object.defineProperty(NglFormGroupElement.prototype, "labelClass", {
        get: function () {
            return "slds-" + this.contentEl.type + (this.groupAlt ? '--button' : '') + "__label";
        },
        enumerable: true,
        configurable: true
    });
    NglFormGroupElement.prototype.ngOnChanges = function (changes) {
        this.setFormLabel();
    };
    NglFormGroupElement.prototype.ngAfterContentInit = function () {
        if (!this.contentEl) {
            throw Error("Couldn't find an input radio or checkbox with [nglFormControl] attribute inside <ngl-form-group-element>");
        }
        var type = this.contentEl.type;
        if (this.groupAlt) {
            this.groupAlt.type = type;
            this.renderer.addClass(this.element.nativeElement, 'slds-button');
            this.renderer.addClass(this.element.nativeElement, "slds-" + type + "--button");
        }
        else {
            this.renderer.addClass(this.element.nativeElement, "slds-" + type);
        }
        this.contentEl.id = this.uid;
        this.setFormLabel();
    };
    NglFormGroupElement.prototype.setFormLabel = function () {
        this._label = getFormLabel(this.labelStr, this.labelTpl);
    };
    NglFormGroupElement.decorators = [
        { type: Component, args: [{
                    selector: 'ngl-form-group-element',
                    template: "\n    <ng-content></ng-content><label *ngIf=\"contentEl\" [ngClass]=\"labelClass\" [attr.for]=\"uid\" [ngSwitch]=\"!!groupAlt\"><ng-container *ngSwitchCase=\"false\"><span [ngClass]=\"'slds-' + contentEl.type + '--faux'\"></span><span class=\"slds-form-element__label\" [nglInternalOutlet]=\"_label\"></span></ng-container><ng-container *ngSwitchCase=\"true\"><span [ngClass]=\"'slds-' + contentEl.type + '--faux'\" [nglInternalOutlet]=\"_label\"></span></ng-container></label>\n  ",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                },] },
    ];
    /** @nocollapse */
    NglFormGroupElement.ctorParameters = function () { return [
        { type: NglFormGroupAlternate, decorators: [{ type: Optional },] },
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    NglFormGroupElement.propDecorators = {
        'contentEl': [{ type: ContentChild, args: [NglFormCheckbox,] },],
        'labelStr': [{ type: Input, args: ['label',] },],
        'labelTpl': [{ type: ContentChild, args: [NglFormLabelTemplate,] },],
    };
    return NglFormGroupElement;
}());
export { NglFormGroupElement };
;
//# sourceMappingURL=element.js.map